var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5563 7.31877C13.5313 7.26252 13.5 7.21252 13.4563 7.16877L11.5813 5.29377C11.4 5.11252 11.1 5.11252 10.9187 5.29377C10.7375 5.47502 10.7375 5.77502 10.9187 5.95627L11.9938 7.03127H1.875C1.61875 7.03127 1.40625 7.24377 1.40625 7.50002C1.40625 7.75627 1.61875 7.96877 1.875 7.96877H11.9938L10.9187 9.04377C10.7375 9.22502 10.7375 9.52502 10.9187 9.70627C11.0125 9.80002 11.1313 9.84377 11.25 9.84377C11.3687 9.84377 11.4875 9.80002 11.5813 9.70627L13.4563 7.83127C13.5 7.78752 13.5313 7.73752 13.5563 7.68127C13.6063 7.56877 13.6063 7.43752 13.5563 7.32502V7.31877Z",
    fill: "#F5F9FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right_arrow.297c07955da7d92891f6560c4eea05d7.svg";
export { ForwardRef as ReactComponent };